import { OrganizationsList } from './pages/OrganizationsList';
import { OrganizationsForm } from './pages/OrganizationsForm';

export const OrganizationsRoutes = [
  {
    path: '/organizacoes',
    component: OrganizationsList,
  },
  {
    path: '/organizacoes/novo',
    component: OrganizationsForm,
  },
  {
    path: '/organizacoes/edit/:id',
    component: OrganizationsForm,
  },
];
